<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const utilityButtonsSnippet = `
    <button class="utility-button">
      <div class="utiltity-button-subtitle">Find the right plan</div>
      <div class="utiltity-button-title">Compare plans</div>
    </button>
  `;

  const borderedUtilityButtonsSnippet = `
    <button class="utility-button utiltity-button-border">
      <div class="utiltity-button-subtitle">Find the right plan</div>
      <div class="utiltity-button-title">Compare plans</div>
    </button>
  `;

  const iconUtilityButtonsSnippet = `
    <button class="utility-button utiltity-button-border">
      <div class="flex flex-row gap-4 items-center">
        <svg width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <g fill-rule="nonzero" fill="currentColor">
            <path d="M18.2361507,10.2168739 C20.5836041,10.2062462 22.7182728,11.5757393 23.6870456,13.7139695 
              C24.6220835,15.7777416 24.3025665,18.1858574 22.8802248,19.9315161 L23.5250329,23.644688 C23.5987584,24.0692415 
              23.1367819,24.3819915 22.7699905,24.1558384 L19.367822,22.0581585 C17.1932339,22.4783728 14.9564771,21.6602027 
              13.5669931,19.9208072 C12.1339726,18.1269116 11.8556821,15.6705338 12.8510614,13.6015174 C13.846427,11.5325295 
              15.9393498,10.2168739 18.2361507,10.2168739 Z M18.2407045,11.2168229 L18.0068147,11.2221589 C16.1856637,11.3055676 
              14.5478221,12.3812518 13.7522016,14.0350453 C12.9234199,15.7577682 13.1551327,17.8030196 14.348307,19.296669 
              C15.5414813,20.7903184 17.4850203,21.4681089 19.3482651,21.0403562 C19.4762925,21.0109644 19.610744,21.033135 
              19.7225568,21.1020755 L22.3498348,22.7219801 L21.8549241,19.8720025 C21.8289229,19.7222727 21.87243,19.5688445 
              21.9731577,19.4550507 C23.2677752,17.9924991 23.5822521,15.9057975 22.7761743,14.12666 C21.9701002,12.3475308 
              20.1939288,11.2080311 18.2407045,11.2168229 Z M3.06733335,4.81958484 C5.05895513,1.64535141 8.68808311,-0.113165562 
              12.4135514,0.290815599 C16.1390198,0.694796761 19.3068452,3.19035962 20.5717612,6.71772446 C20.6649739,6.97765905 
              20.5298192,7.26394155 20.2698846,7.35715431 C20.00995,7.45036707 19.7236675,7.31521233 19.6304548,7.05527773 
              C18.4947716,3.88829357 15.6505937,1.64769515 12.3057457,1.28498758 C8.96089774,0.922280007 5.70254728,2.50113438 
              3.91440374,5.35106555 C2.12626021,8.20099672 2.12222131,11.8217166 3.90400224,14.67563 C3.99438644,14.8204002 
              4.00468493,15.0012728 3.93131738,15.1553666 L3.93131738,15.1553666 L1.80978796,19.6112136 L6.26563494,17.4896842 
              C6.41959719,17.4163793 6.60030283,17.4265939 6.74502343,17.5167822 C7.74268416,18.1385136 8.85519859,18.5532437 
              10.0163903,18.7363029 C10.2891639,18.7793051 10.4754304,19.0352919 10.4324283,19.3080655 C10.3894261,19.580839 
              10.1334394,19.7671056 9.86066577,19.7241035 C8.65802964,19.5345106 7.50226124,19.121859 6.4525942,18.5082302 
              L6.4525942,18.5082302 L0.967648857,21.1197367 C0.542565431,21.3221285 0.0988730698,20.8784361 0.301264893,20.4533527 
              L0.301264893,20.4533527 L2.91264499,14.9686726 L2.75058447,14.6811006 C1.07753847,11.5919137 1.18366018,7.82177049 
              3.06733335,4.81958484 Z" transform="translate(-.235 -.232)"/><path d="M19.8898341,17.1063542 C20.1659765,17.1063542 
              20.3898341,17.3302118 20.3898341,17.6063542 C20.3898341,17.8824966 20.1659765,18.1063542 19.8898341,18.1063542 
              L19.8898341,18.1063542 L16.8278938,18.1063542 C16.5517514,18.1063542 16.3278938,17.8824966 16.3278938,17.6063542 
              C16.3278938,17.3302118 16.5517514,17.1063542 16.8278938,17.1063542 L16.8278938,17.1063542 Z M19.8898341,14.0444139 
              C20.1659765,14.0444139 20.3898341,14.2682715 20.3898341,14.5444139 C20.3898341,14.8205562 20.1659765,15.0444139 
              19.8898341,15.0444139 L19.8898341,15.0444139 L16.8278938,15.0444139 C16.5517514,15.0444139 16.3278938,14.8205562 
              16.3278938,14.5444139 C16.3278938,14.2682715 16.5517514,14.0444139 16.8278938,14.0444139 L16.8278938,14.0444139 Z 
              M9.93852802,10.9824735 C10.2146704,10.9824735 10.438528,11.2063312 10.438528,11.4824735 C10.438528,11.7586159 
              10.2146704,11.9824735 9.93852802,11.9824735 L9.93852802,11.9824735 L6.8765877,11.9824735 C6.60044532,11.9824735 
              6.3765877,11.7586159 6.3765877,11.4824735 C6.3765877,11.2063312 6.60044532,10.9824735 6.8765877,10.9824735 
              L6.8765877,10.9824735 Z M14.5314385,6.38956304 C14.8075809,6.38956304 15.0314385,6.61342066 15.0314385,6.88956304 
              C15.0314385,7.16570541 14.8075809,7.38956304 14.5314385,7.38956304 L14.5314385,7.38956304 L6.8765877,7.38956304 
              C6.60044532,7.38956304 6.3765877,7.16570541 6.3765877,6.88956304 C6.3765877,6.61342066 6.60044532,6.38956304 
              6.8765877,6.38956304 L6.8765877,6.38956304 Z" transform="translate(-.235 -.232)"/>
          </g>
        </svg>
        <div>
          <div class="utiltity-button-subtitle">Find the right plan</div>
          <div class="utiltity-button-title">Compare plans</div>
        </div>
      </div>
    </button>
  `;

  const multipleUtilityButtonsSnippet = `
  <div class="p-4 bg-lightest grid gap-4 xl:grid-flow-col xl:grid-cols-3">
    <button class="utility-button">
      <div class="utiltity-button-subtitle">Find the right plan</div>
      <div class="utiltity-button-title">Compare plans</div>
    </button>
    <button class="utility-button">
      <div class="utiltity-button-subtitle">Find the right plan</div>
      <div class="utiltity-button-title">Compare plans</div>
    </button>
    <button class="utility-button">
      <div class="utiltity-button-subtitle">Find the right plan</div>
      <div class="utiltity-button-title">Compare plans</div>
    </button>
  </div>
  `;
</script>

<template>
  <section id="utility-button" class="page-section bg-sageGreen40">
    <div class="container">
      <h2 class="heading heading-2 my-6">Utility Button</h2>
      <div class="m-auto">
        <h3 class="heading heading-3 mt-8 mb-6">Default</h3>
        {@html utilityButtonsSnippet}
        <CodeSnippet id="utility-buttons" snippet={utilityButtonsSnippet} />

        <h3 class="heading heading-3 mt-8 mb-6">Bordered</h3>
        {@html borderedUtilityButtonsSnippet}
        <CodeSnippet id="utility-buttons-border" snippet={borderedUtilityButtonsSnippet} />

        <h3 class="heading heading-3 mt-8 mb-6">With Icon</h3>
        {@html iconUtilityButtonsSnippet}
        <CodeSnippet id="utility-buttons-with-icon" snippet={iconUtilityButtonsSnippet} />

        <h3 class="heading heading-3 mt-8 mb-6">Multiple</h3>
        {@html multipleUtilityButtonsSnippet}
        <CodeSnippet id="utility-buttons-many" snippet={multipleUtilityButtonsSnippet} />
      </div>
    </div>
  </section>
</template>
